import type { RootStoreState } from "@jti/store/types";

export type PreloadedStateSlice = Partial<RootStoreState> | undefined;

export const buildPreloadedState = (...slices: PreloadedStateSlice[]): Partial<RootStoreState> | undefined => {
  const definedSlices = slices.filter((slice): slice is Partial<RootStoreState> => Boolean(slice));

  if (definedSlices.length === 0) {
    return undefined;
  }

  return Object.assign({}, ...definedSlices);
};
